import _createForOfIteratorHelper from "/var/www/vhosts/jidlopodnos.cz/nove.jidlopodnos.cz/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/var/www/vhosts/jidlopodnos.cz/nove.jidlopodnos.cz/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/www/vhosts/jidlopodnos.cz/nove.jidlopodnos.cz/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/www/vhosts/jidlopodnos.cz/nove.jidlopodnos.cz/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/vhosts/jidlopodnos.cz/nove.jidlopodnos.cz/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/www/vhosts/jidlopodnos.cz/nove.jidlopodnos.cz/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/var/www/vhosts/jidlopodnos.cz/nove.jidlopodnos.cz/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { WebPlugin } from '@capacitor/core';
export var DeviceWeb = /*#__PURE__*/function (_WebPlugin) {
  _inherits(DeviceWeb, _WebPlugin);

  var _super = _createSuper(DeviceWeb);

  function DeviceWeb() {
    _classCallCheck(this, DeviceWeb);

    return _super.apply(this, arguments);
  }

  _createClass(DeviceWeb, [{
    key: "getId",
    value: function () {
      var _getId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", {
                  uuid: this.getUid()
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getId() {
        return _getId.apply(this, arguments);
      }

      return getId;
    }()
  }, {
    key: "getInfo",
    value: function () {
      var _getInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var ua, uaFields;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(typeof navigator === 'undefined' || !navigator.userAgent)) {
                  _context2.next = 2;
                  break;
                }

                throw this.unavailable('Device API not available in this browser');

              case 2:
                ua = navigator.userAgent;
                uaFields = this.parseUa(ua);
                return _context2.abrupt("return", {
                  model: uaFields.model,
                  platform: 'web',
                  operatingSystem: uaFields.operatingSystem,
                  osVersion: uaFields.osVersion,
                  manufacturer: navigator.vendor,
                  isVirtual: false,
                  webViewVersion: uaFields.browserVersion
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getInfo() {
        return _getInfo.apply(this, arguments);
      }

      return getInfo;
    }()
  }, {
    key: "getBatteryInfo",
    value: function () {
      var _getBatteryInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var battery;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(typeof navigator === 'undefined' || !navigator.getBattery)) {
                  _context3.next = 2;
                  break;
                }

                throw this.unavailable('Device API not available in this browser');

              case 2:
                battery = {};
                _context3.prev = 3;
                _context3.next = 6;
                return navigator.getBattery();

              case 6:
                battery = _context3.sent;
                _context3.next = 11;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](3);

              case 11:
                return _context3.abrupt("return", {
                  batteryLevel: battery.level,
                  isCharging: battery.charging
                });

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 9]]);
      }));

      function getBatteryInfo() {
        return _getBatteryInfo.apply(this, arguments);
      }

      return getBatteryInfo;
    }()
  }, {
    key: "getLanguageCode",
    value: function () {
      var _getLanguageCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", {
                  value: navigator.language
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getLanguageCode() {
        return _getLanguageCode.apply(this, arguments);
      }

      return getLanguageCode;
    }()
  }, {
    key: "parseUa",
    value: function parseUa(ua) {
      var uaFields = {};
      var start = ua.indexOf('(') + 1;
      var end = ua.indexOf(') AppleWebKit');

      if (ua.indexOf(') Gecko') !== -1) {
        end = ua.indexOf(') Gecko');
      }

      var fields = ua.substring(start, end);

      if (ua.indexOf('Android') !== -1) {
        var tmpFields = fields.replace('; wv', '').split('; ').pop();

        if (tmpFields) {
          uaFields.model = tmpFields.split(' Build')[0];
        }

        uaFields.osVersion = fields.split('; ')[1];
      } else {
        uaFields.model = fields.split('; ')[0];

        if (typeof navigator !== 'undefined' && navigator.oscpu) {
          uaFields.osVersion = navigator.oscpu;
        } else {
          if (ua.indexOf('Windows') !== -1) {
            uaFields.osVersion = fields;
          } else {
            var _tmpFields = fields.split('; ').pop();

            if (_tmpFields) {
              var lastParts = _tmpFields.replace(' like Mac OS X', '').split(' ');

              uaFields.osVersion = lastParts[lastParts.length - 1].replace(/_/g, '.');
            }
          }
        }
      }

      if (/android/i.test(ua)) {
        uaFields.operatingSystem = 'android';
      } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
        uaFields.operatingSystem = 'ios';
      } else if (/Win/.test(ua)) {
        uaFields.operatingSystem = 'windows';
      } else if (/Mac/i.test(ua)) {
        uaFields.operatingSystem = 'mac';
      } else {
        uaFields.operatingSystem = 'unknown';
      } // Check for browsers based on non-standard javascript apis, only not user agent


      var isFirefox = !!window.InstallTrigger;
      var isSafari = !!window.ApplePaySession;
      var isChrome = !!window.chrome;
      var isEdge = /Edg/.test(ua);
      var isFirefoxIOS = /FxiOS/.test(ua);
      var isChromeIOS = /CriOS/.test(ua);
      var isEdgeIOS = /EdgiOS/.test(ua); // FF and Edge User Agents both end with "/MAJOR.MINOR"

      if (isSafari || isChrome && !isEdge || isFirefoxIOS || isChromeIOS || isEdgeIOS) {
        // Safari version comes as     "... Version/MAJOR.MINOR ..."
        // Chrome version comes as     "... Chrome/MAJOR.MINOR ..."
        // FirefoxIOS version comes as "... FxiOS/MAJOR.MINOR ..."
        // ChromeIOS version comes as  "... CriOS/MAJOR.MINOR ..."
        var searchWord;

        if (isFirefoxIOS) {
          searchWord = 'FxiOS';
        } else if (isChromeIOS) {
          searchWord = 'CriOS';
        } else if (isEdgeIOS) {
          searchWord = 'EdgiOS';
        } else if (isSafari) {
          searchWord = 'Version';
        } else {
          searchWord = 'Chrome';
        }

        var words = ua.split(' ');

        var _iterator = _createForOfIteratorHelper(words),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var word = _step.value;

            if (word.includes(searchWord)) {
              var version = word.split('/')[1];
              uaFields.browserVersion = version;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else if (isFirefox || isEdge) {
        var reverseUA = ua.split('').reverse().join('');
        var reverseVersion = reverseUA.split('/')[0];

        var _version = reverseVersion.split('').reverse().join('');

        uaFields.browserVersion = _version;
      }

      return uaFields;
    }
  }, {
    key: "getUid",
    value: function getUid() {
      if (typeof window !== 'undefined') {
        var uid = window.localStorage.getItem('_capuid');

        if (uid) {
          return uid;
        }

        uid = this.uuid4();
        window.localStorage.setItem('_capuid', uid);
        return uid;
      }

      return this.uuid4();
    }
  }, {
    key: "uuid4",
    value: function uuid4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }]);

  return DeviceWeb;
}(WebPlugin);